














































































































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Actor } from '@/data/models/actor.model';
import { Veicolo } from '@/data/models/veicolo.model';
import { date2Num, dateEndofDay, newDate } from '@/data/utils/helper';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Contatto } from '@/data/models/contatto.model';

@Component
export default class ServizioFilter extends Vue {

	advancedSearch: Search;
	veicoloClass: ClassType<Veicolo> = Veicolo;
	veicoloSearch: Search = new Search('vehicle');
	actorClass: ClassType<Actor> = Actor;
	actorSearch: Search = new Search('actor');
	operatoreClass: ClassType<Actor> = Actor;
	operatoreSearch: Search = new Search('actor');
	payerClass: ClassType<Actor> = Actor;
	payerSearch: Search = new Search('actor');

	searchParam: any = new class {
		startdate?: Date[];
		vehicle?: Veicolo;
		operatore?: Actor;
		patient?: Actor;
		payer?: Actor;
	};

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('serviceinstance');
		this.actorSearch.addNotEqualFilter('patientid', null);
		this.actorSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.payerSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.veicoloSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('candrive', 1);
		this.operatoreSearch.addNotEqualFilter('volunteerid', null);
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.startdate && this.searchParam.startdate.length) {
			const start = this.searchParam.startdate[0] ? date2Num(this.searchParam.startdate[0]) : 0;
			const end = this.searchParam.startdate[1] ? date2Num(dateEndofDay(this.searchParam.startdate[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('startdate', start as number, end as number);
		}
		
		if (this.searchParam.operatore && this.searchParam.operatore.id) this.advancedSearch.addSimpleFilter('driverid', this.searchParam.operatore.id);
		if (this.searchParam.vehicle && this.searchParam.vehicle.id) this.advancedSearch.addSimpleFilter('vehicleid', this.searchParam.vehicle.id);
		if (this.searchParam.patient && this.searchParam.patient.id) this.advancedSearch.addSimpleFilter('patientid', this.searchParam.patient.id);
		if (this.searchParam.payer && this.searchParam.payer.id) this.advancedSearch.addSimpleFilter('payerid', this.searchParam.payer.id);

		this.$emit('search', this.advancedSearch);
		this.onUpdateParams();
	}

	reset() {
		this.searchParam.startdate = [];
		this.searchParam.enddate = [];
		this.searchParam.vehicle = {};
		this.searchParam.operatore = {};
		this.searchParam.patient = {};
		this.searchParam.payer = {};
		
		this.search();
	}

	onUpdateParams() {
		this.$emit('params', this.searchParam);
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.address ? contact.address : ''} ${contact.streetno ? contact.streetno : ''}`;
		}
	}

	operatoreFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	}

}
